export enum PolicyType {
    LowLimit = 'lowlimit',
    PreApproved = 'preapproved',
    FinancialActivities = 'financial-activities',
    CreditScorePG = 'credit-score-pg',
    CreditScoreAnnualRevenue = 'credit-score-annual-revenue',
    CreditScoreIdVerification = 'credit-score-id-verification',
    BondRating = 'bond-rating',
    Manual = 'manual',
    Assessment = 'assessment',
}
